import { useSyncExternalStore } from 'react'

// Per-device "mute opponent emotes" preference (PvP emotes). Shared by the Settings dialog row
// and the play-area emote picker, so both controls always show the same state.
const STORAGE_KEY = 'pvpEmotesMuted'
const CHANGE_EVENT = 'pvpEmotesMutedChange'

let memoryValue = false

export const getEmotesMuted = (): boolean => {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'true'
    } catch {
        return memoryValue
    }
}

export const setEmotesMuted = (muted: boolean) => {
    memoryValue = muted
    try {
        localStorage.setItem(STORAGE_KEY, String(muted))
    } catch {
        // storage blocked (private mode): the in-memory value still applies for this tab
    }
    window.dispatchEvent(new Event(CHANGE_EVENT))
}

const subscribe = (onChange: () => void) => {
    window.addEventListener(CHANGE_EVENT, onChange)
    window.addEventListener('storage', onChange)
    return () => {
        window.removeEventListener(CHANGE_EVENT, onChange)
        window.removeEventListener('storage', onChange)
    }
}

export const useEmotesMuted = () => useSyncExternalStore(subscribe, getEmotesMuted, () => false)
